<script>
    import { getUserData } from "../controllers/APIController";
    import { scoreToString } from "../controllers/PokerLogic";
    
    let statsPanel;
    let myStats;
    let otherStats;
    
    export async function show(myId, otherId)
    {
        myStats = null;
        otherStats = null;
        statsPanel.style.display = "block";

        myStats = await getUserData(myId);
        console.log("myStats: " + JSON.stringify(myStats));

        if (otherId)
        {
            otherStats = await getUserData(otherId);
            console.log("otherStats: " + JSON.stringify(otherStats));
        }
    }

    export function hide()
    {
        statsPanel.style.display = "none";
    }

    function getPercent(value)
    {
        if (!value)
            return "-";
        
        return Math.round(value * 100) + "%";
    }

    function getBestHand(value)
    {
        return scoreToString(value);
    }

</script>

<ion-card class="panel" bind:this={statsPanel} style="display: none;">
    <div style="text-align: right; width: 100%; padding: 10px;"><a style="cursor: pointer;" on:click={hide}>X</a></div>
    <ion-card-header style="text-align: center;">
        <ion-card-title>Player Stats</ion-card-title>
    </ion-card-header>
  
    <ion-card-content style="text-align: left; width: 100%;">
        {#if myStats}
        <div class="vbox" style="width: 100%;">
            <table>
                <tr>
                    <th>Stats</th>
                    <th>Myself</th>
                    {#if otherStats}
                    <th>{otherStats.name}</th>
                    {/if}
                </tr>
                <tr>
                    <td>Pre-flop fold</td>
                    <td>{getPercent(myStats.fold_preflop / myStats.hands_dealt)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.fold_preflop / otherStats.hands_dealt)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Flop fold</td>
                    <td>{getPercent(myStats.fold_flop / myStats.hands_reaching_flop)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.fold_flop / otherStats.hands_reaching_flop)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Turn fold</td>
                    <td>{getPercent(myStats.fold_turn / myStats.hands_reaching_turn)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.fold_turn / otherStats.hands_reaching_turn)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>River fold</td>
                    <td>{getPercent(myStats.fold_river / myStats.hands_reaching_river)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.fold_river / otherStats.hands_reaching_river)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Raise Frequency</td>
                    <td>{getPercent(myStats.raises / myStats.actions)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.raises / otherStats.actions)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Hands Played</td>
                    <td>{myStats.hands_dealt}</td>
                    {#if otherStats}
                    <td>{otherStats.hands_dealt}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Win Percentage</td>
                    <td>{getPercent(myStats.hands_won / myStats.hands_dealt)}</td>
                    {#if otherStats}
                    <td>{getPercent(otherStats.hands_won / otherStats.hands_dealt)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Best winning hand</td>
                    <td>{getBestHand(myStats.best_winning_hand)}</td>
                    {#if otherStats}
                    <td>{getBestHand(otherStats.best_winning_hand)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Average Winnings per Hand</td>
                    <td>{!myStats.hands_dealt ? "-" : Math.round(myStats.sum_all_wins / myStats.hands_dealt)}</td>
                    {#if otherStats}
                    <td>{!otherStats.hands_dealt ? "-" : Math.round(otherStats.sum_all_wins / otherStats.hands_dealt)}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Biggest Pot Won</td>
                    <td>{myStats.biggest_win}</td>
                    {#if otherStats}
                    <td>{otherStats.biggest_win}</td>
                    {/if}
                </tr>
                <tr>
                    <td>Highest stakes played</td>
                    <td>{myStats.highest_stakes} / {myStats.highest_stakes * 2}</td>
                    {#if otherStats}
                    <td>{otherStats.highest_stakes} / {otherStats.highest_stakes * 2}</td>
                    {/if}
                </tr>
            </table>
        </div>
        {:else}
        Loading...
        {/if}
    </ion-card-content>
    
</ion-card>

<style>
    .panel {
        position: absolute;
        width: 600px;
        height: 420px;
        left: 140px;
        top: 100px;
    }

    .profilePhoto {
        width: 100px;
        height: 100px;
    }
</style>